import { data } from '../../svg/Target/data';
import { makeIcon } from '../makeIcon';

export const Target = makeIcon(data, 'target', 'Target');

export default Target;
